import React, { useContext } from 'react';
import currency from 'currency.js';
import { ApplicationUIContext, colors, Table } from '@yuhuinc/ui-library';
import { getTranslatedString } from 'helpers/i18n';
import { Space, Typography } from 'antd';
const { Link, Text, Title } = Typography;
const gray = colors.colors.gray[9];

const StrongText = ({ children }) => (
  <Text strong style={{ color: gray }}>
    {children}
  </Text>
);

// TODO: Fetch real data and remove this
const FAKE_DATASOURCE = [
  {
    key: '1',
    name: 'Geraldine Blanchard',
    userType: 'Applicant',
    income: 80_000.0,
    assets: 15_032.0,
  },
  { key: '2', name: 'Tierra Singh', userType: 'Applicant', income: 65_000.0, assets: 7_032.0 },
  { key: '3', name: 'Afsun Kayode', userType: 'Guarantor', income: 156_500.0, assets: 75_032.0 },
];

const renderRegularText = (value) => <Text>{value}</Text>;
const renderCurrency = (value) => <Text>{currency(value).format()}</Text>;

const columns = [
  {
    title: (
      <StrongText>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.incomeVerification.name'
        )}
      </StrongText>
    ),
    dataIndex: 'name',
    key: 'name',
    width: '40%',
    render: renderRegularText,
  },
  {
    title: (
      <StrongText>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.incomeVerification.userType'
        )}
      </StrongText>
    ),
    dataIndex: 'userType',
    key: 'userType',
    width: '40%',
    render: renderRegularText,
  },
  {
    title: (
      <StrongText>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.incomeVerification.income'
        )}
      </StrongText>
    ),
    dataIndex: 'income',
    key: 'income',
    align: 'right',
    render: renderCurrency,
  },
  {
    title: (
      <StrongText>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.incomeVerification.assets'
        )}
      </StrongText>
    ),
    dataIndex: 'assets',
    key: 'assets',
    align: 'right',
    render: renderCurrency,
  },
];

const IncomeVerification = () => {
  const { isMobile } = useContext(ApplicationUIContext);

  const totalSummary = (pageData) => {
    // Do not render summary if there is no data
    if (!pageData?.length) {
      return null;
    }

    const totalIncome = currency(pageData.reduce((acc, curr) => acc + curr.income, 0)).format();
    const totalAssets = currency(pageData.reduce((acc, curr) => acc + curr.assets, 0)).format();

    return (
      <>
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={2}>
            <StrongText>
              {getTranslatedString(
                'landlordPortal.applicationManagement.applicationOverview.review.incomeVerification.total'
              )}
            </StrongText>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={1} align="right">
            <StrongText>{totalIncome}</StrongText>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={2} align="right">
            <StrongText>{totalAssets}</StrongText>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </>
    );
  };

  return (
    <>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.incomeVerification'
        )}
      </Title>

      <Space />

      <Table
        pagination={{ hideOnSinglePage: true }}
        dataSource={FAKE_DATASOURCE}
        columns={columns}
        summary={totalSummary}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
      />
    </>
  );
};

export { IncomeVerification };
